// extracted by mini-css-extract-plugin
module.exports = {"advert":"_1mKc9","advertImg":"_2M6XL"};